import * as React from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';

class ToggleField extends React.PureComponent<any, any> {
  public render() {
    const { field, value, onChange } = this.props;
    return (
      <FormControlLabel
        key={field.field}
        control={
          <Switch
            checked={value}
            onChange={onChange}
            id={field.field}
          />
        }
        label={field.label}
      />
    );
  }
}

export default ToggleField;



// WEBPACK FOOTER //
// ./src/modules/subscription/components/SubscriptionConfig/ToggleField.tsx